<template>
  <div class="home">
    <div class="home__header">
      <div class="home__hamburger">
        <a href="#" class="home__hamburger__a"
        @click.prevent="categoryOpen = !categoryOpen">
          <img src="@/assets/icon/main_menu_hamburger.png"
          alt="商品類別選單"
          class="home__hamburger--folded"
          v-if="!categoryOpen">
          <img src="@/assets/icon/close_menu.png"
          alt="關閉商品類別選單"
          class="home__hamburger--cross"
          v-if="categoryOpen">
        </a>
      </div>
      <div class="home__nav--rwdM">
        <slide-nav
        :parent='`home__nav--rwdM`'
        :data='headerNavData'>
        </slide-nav>
      </div>
      <div class="home__nav--rwdL">
        <ul class="list">
          <li class="list__item"
          v-for="(item, index) in headerNavData"
          :key="index">
            <a href="#" class="list__a"
            @click="go_page(item.route)">
              <span class="list__chinese">
                {{item.chinese}}
              </span>
              <span class="list__english">
                {{item.english}}
              </span>
            </a>
          </li>
        </ul>
      </div>
      <ul class="home__sharelinks">
        <li class="home__sharelinks__item">
          <a href="#" class="home__sharelinks__a">
            <img src="@/assets/icon/main_menu_fb.png"
            alt="FB粉絲專頁"
            class="home__sharelinks__rwdM">
            <img src="@/assets/icon/facebook_icon.png"
            alt="FB粉絲專頁"
            class="home__sharelinks__rwdL">
          </a>
        </li>
        <li class="home__sharelinks__item">
          <a href="#" class="home__sharelinks__a">
            <img src="@/assets/icon/main_menu_line.png"
            alt="Line官方帳號"
            class="home__sharelinks__rwdM">
            <img src="@/assets/icon/line_icon.png"
            alt="Line官方帳號"
            class="home__sharelinks__rwdL">
          </a>
        </li>
        <li class="home__sharelinks__item">
          <a href="#" class="home__sharelinks__a">
            <img src="@/assets/icon/main_menu_ig.png"
            alt="追蹤IG"
            class="home__sharelinks__rwdM">
            <img src="@/assets/icon/instagram_icon.png"
            alt="追蹤IG"
            class="home__sharelinks__rwdL">
          </a>
        </li>
      </ul>
    </div>
    <div class="home__category"
    v-if="categoryOpen">
      <div class="home__category__container">
        <slide-nav
        :parent='`home__category`'
        :data='categoryData'>
        </slide-nav>
      </div>
    </div>
    <div class="home__banner">
      <div class="home__banner__bgimg">
        <transition name="fade"
        v-for="(item, index) in bgimgList"
        :key="index">
          <img class="home__banner__bgimg__img"
          :src="item.img" :alt="item.title"
          v-if="item.isShown">
        </transition>
      </div>
      <div class="home__banner__logo">
        <img class="home__banner__logo__img"
        src="@/assets/banner_logo.png" alt="">
      </div>
      <div class="home__banner__shopIcon">
        <img class="home__banner__shopIcon__img"
        src="@/assets/icon/banner_store_link.png" alt="">
      </div>
      <div class="home__banner__link">
        <a href="#" @click='go_page(bgimgLink)'
        class="home__banner__link__a"></a>
      </div>
      <div class="home__banner__bgimgControl">
        <ul class="bgimgControl">
          <li class="bgimgControl__item"
          v-for="(item, index) in bgimgList"
          :key="index">
            <a href="#" class="bgimgControl__a"
            @click.prevent='changeBgimg(index)'>
              <div class="bgimgControl__circle"
              :class="{active: item.isShown}"></div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="home__footer">
      <div class="home__footer__logo">
        <img src="@/assets/footer_logo.png" alt="">
      </div>
      <div class="home__footer__copyright">
        <p>COPYRIGHT FLORALDESIGN © ALL RIGHTS RESERVED.</p>
      </div>
      <div class="home__footer__contacts">
        <ul class="contacts">
          <li class="contacts__item">
            <a href="#" class="contacts__a">
              Tel: (02) 1234-5678
            </a>
          </li>
          <li class="contacts__item">
            <a href="#" class="contacts__a">
              Line: @lineme.com
            </a>
          </li>
          <li class="contacts__item">
            <a href="#" class="contacts__a">
              Mail: service@floraldesign.com
            </a>
          </li>
          <li class="contacts__item">
            <p class="contacts__p">
              100台北市中正區重慶南路一段122號
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery';
import slideNav from '@/components/SlideNav.vue';

export default {
  components: {
    slideNav,
  },
  data() {
    return {
      bgimgInterval: null,
      bgimgList: [],
      categoryOpen: false,
    };
  },
  computed: {
    headerNavData() {
      const arr = this.$router.options.routes
        .find((item) => item.name === 'Front').children
        .filter((item) => item.onNav === true)
        .map((item) => {
          const newObj = {};
          /* eslint-disable */
          item.path = item.path === 'onlinestore' ? 'onlinestore/all' : item.path;
          /* eslint-enable */
          newObj.route = `/front/${item.path}`;
          newObj.english = item.name;
          newObj.chinese = item.chinese;
          return newObj;
        });
      return arr;
    },
    categoryData() {
      let arr;
      this.$bus.$on('son_get_data', (data) => {
        arr = data.products;
      });
      this.$bus.$emit('son_call_data');
      arr = arr.map((item) => item.category).flat(2)
        .map((item) => JSON.stringify(item));
      arr = [...new Set(arr)]
        .sort()
        .map((item) => JSON.parse(item))
        .map((item) => {
          const newObj = {};
          newObj.chinese = item.chinese;
          newObj.route = `/front/onlinestore/${item.english}`;
          return newObj;
        });
      return arr;
    },
    bgimgLink() {
      const result = this.bgimgList
        .find((item) => item.isShown === true)
        .route;
      return result;
    },
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    changeBgimg(index) {
      this.end_interval();
      this.bgimgList.find((item) => item.isShown === true)
        .isShown = false;
      this.bgimgList[index].isShown = true;
      this.start_interval();
    },
    set_interval() {
      this.bgimgInterval = setInterval(() => {
        let shownIndex = this.bgimgList
          .findIndex((item) => item.isShown === true);
        shownIndex = shownIndex + 1 === this.bgimgList.length ? 0 : shownIndex + 1;
        this.bgimgList.find((item) => item.isShown === true)
          .isShown = false;
        this.bgimgList[shownIndex].isShown = true;
      }, 5000);
    },
    start_interval() {
      this.set_interval();
    },
    end_interval() {
      clearInterval(this.bgimgInterval);
    },
  },
  created() {
    document.title = '艸芊芳芫 | Floral Design';

    // data bgimgList
    let arr;
    this.$bus.$on('son_get_data', (data) => {
      arr = data.products;
    });
    this.$bus.$emit('son_call_data');
    arr = arr.filter((item) => item.on_banner === true)
      .map((item) => {
        const newObj = {};
        newObj.title = item.title;
        newObj.img = item.images.banner;
        newObj.route = `/front/onlinestore/all/${item.id}`;
        newObj.isShown = false;
        return newObj;
      });
    arr[0].isShown = true;
    this.bgimgList = arr;
    // data bgimgList end

    this.start_interval();
  },
};
</script>
